class DatepickerInlineConnectedInputListener extends AbstractInputListener
{

    listen()
    {
        let context = this;

        $(document).on('click', context.selector, function (e){

            let parent = $(this).closest('div');

            let element = parent.find('.calendar');

            $('.calendar').not(element).addClass('hide');

            element.toggleClass('hide');

        });

    }

}